<!-- Placeholder label -->
<!-- labels not supported for form buttons in 4.0 -->
<label
    *ngIf="lmColumnLayoutInfo?.nbrColumns > 1 && !lmParagraphLayoutInfo?.parentIsParagraphLayout && !field.label"
    lm-label
      [layoutField] = "field"
      [layoutInfo]="layoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
>
  &nbsp;
</label>

<ng-container [ngSwitch]="displayType">
  <!-- DISPLAY AS BUTTON -->
  <ng-container *ngSwitchCase="layoutDisplayType.TEXT_BUTTON">
    <!-- email button with out user defined icon -->
    <button *ngIf="!iconUrl"
        [attr.id]="id"
        soho-button="{{buttonType}}"
        [ngClass]="{'lm-data-view-button-has-data': (isDataViewFieldButton && dataViewFieldButtonHasData)}"
        [class]="buttonBackgroundClass"
        icon="{{buttonIcon}}"
        (click)="onClickEvent($event)"
        (fieldEvent)="onFieldEvent($event)"
        (blur)="onFieldBlur($event)"
        lm-field-style [fieldStyle]="field?.fieldStyle" [recalculateStyles]="triggerValueChange | async"
        [disabled]="!valid"
        soho-alert
        soho-tooltip content="{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}"
    >{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</button>
    <ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="layoutDisplayType.ICON_BUTTON">
    <!-- email button with user defined icon -->
    <ng-container *ngIf="validSohoIcon">
      <button
          [attr.id]="id"
          soho-button="{{buttonType}}"
          icon="{{buttonIcon}}"
          (click)="onClickEvent($event)"
          (fieldEvent)="onFieldEvent($event)"
          (blur)="onFieldBlur($event)"
          [disabled]="!valid"
          [class.personalize-actionable]="personalize"
          [class]="buttonBackgroundClass"
          soho-alert
          soho-tooltip content="{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}"
      >
        <span>{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</span>
      </button>
    </ng-container>
    <ng-container *ngIf="!validSohoIcon">
      <button
          [attr.id]="id"
          [ngClass]="{'lm-form-icon-button': !layoutObject.title, 'btn-secondary': layoutObject.title}"
          [style.background-image]="layoutObject.icon && !layoutObject.title ? 'url(' + layoutObject.iconUrl + ')' : null"
          (click)="onClickEvent($event)"
          (fieldEvent)="onFieldEvent($event)"
          (blur)="onFieldBlur($event)"
          [disabled]="!valid"
          [class.personalize-actionable]="personalize"
          [class]="buttonBackgroundClass"
          soho-alert
          soho-tooltip content="{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}"
      >
        <!-- decorative image, alt can be left blank since it's contained in a button -->
        <img *ngIf="layoutObject.title" src="{{layoutObject.iconUrl}}}" alt=""/>
        <span>{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</span>
      </button>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="layoutDisplayType.TEXT_MAIL_BUTTON">
    <!-- email button with out user defined icon -->
    <button *ngIf="!iconUrl"
        [attr.id]="id"
        soho-button="{{buttonType}}"
        icon="{{buttonIcon}}"
        (click)="mailTo()"
        (fieldEvent)="onFieldEvent($event)"
        (blur)="onFieldBlur($event)"
        [disabled]="!valid"
        [class]="buttonBackgroundClass"
        soho-alert
        soho-tooltip content="{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}"
    >{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</button>
  </ng-container>

  <ng-container *ngSwitchCase="layoutDisplayType.ICON_MAIL_BUTTON">
    <!-- email button with user defined icon -->
    <button *ngIf="iconUrl"
        [attr.id]="id"
        soho-button="{{buttonType}}"
        icon="{{buttonIcon}}"
        (click)="mailTo()"
        (fieldEvent)="onFieldEvent($event)"
        (blur)="onFieldBlur($event)"
        [disabled]="!valid"
        [class.personalize-actionable]="personalize"
        [class]="buttonBackgroundClass"
        soho-alert
        soho-tooltip content="{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}"
    >
      <span>{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</span>
    </button>
  </ng-container>

  <!-- DISPLAY AS LINK -->
  <div *ngSwitchCase="layoutDisplayType.TEXT_LINK" soho-button icon="buttonIcon">
    <lm-hyperlink
      [specFields]="specFields"
      [model]="model"
      [layoutObject]="layoutObject"
      [layoutInfo]="layoutInfo"
      (fieldEvent)="onFieldEvent($event)"
      (click)="fireInitialValueRule()"
    >
    </lm-hyperlink>
  </div>

  <!-- display as tag -->
  <ng-container *ngSwitchCase="layoutDisplayType.TAG">
    <a
      class="tag is-clickable"
      [attr.id]="id"
      [attr.tabindex]="isInAccessibilityMode ? 0 : null"
      [class.data]="true"
      [style.color]="!!tagStyle?.style?.color ? 'white' : null"
      [style.cursor]="valid ? 'pointer' : 'default'"
      soho-alert
      lm-field-style
        [fieldStyle]="tagStyle?.style"
        [isTag]="true"
        [recalculateStyles]="triggerValueChange | async"
      (click)="valid ? onClickEvent($event) : null"
      (fieldEvent)="onFieldEvent($event)"
      (blur)="onFieldBlur($event)"
    >
      <span>{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</span>
      <span>
        <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
          <use xlink:href="#icon-caret-right"></use>
        </svg>
        <span class="audible"></span>
      </span>
    </a>
    <ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="layoutDisplayType.MAIL_LINK">
    <lm-hyperlink
      [specFields]="specFields"
      [model]="model"
      [layoutObject]="layoutObject"
      [layoutInfo]="layoutInfo"
      (fieldEvent)="onFieldEvent($event)"
    >
    </lm-hyperlink>
  </ng-container>
</ng-container>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
      [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>